import { createFileRoute } from '@tanstack/react-router';
import { useActiveCompanyId } from '../../stores/useCompanyStore';
import {
  useLocations,
  useCreateLocation,
  useUpdateLocation,
  useDeactivateLocation,
} from '../../hooks/useDimensions';
import { DimensionPage } from '../../components/dimensions/DimensionPage';

export const Route = createFileRoute('/_auth/locations')({
  component: LocationsPage,
});

function LocationsPage() {
  const companyId = useActiveCompanyId();
  return (
    <DimensionPage
      companyId={companyId}
      title="Locations"
      singular="location"
      hideInactiveKey="accounting:locations:hideInactive"
      hooks={{
        useList: useLocations,
        useCreate: useCreateLocation,
        useUpdate: useUpdateLocation,
        useDeactivate: useDeactivateLocation,
      }}
    />
  );
}
